import {Injectable} from '@angular/core';
import {AuthService} from './auth.service';
import {HttpClientWrapperService} from '../config/http-client-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private authService: AuthService,
              private http: HttpClientWrapperService) {
  }

  uploadFileWithLinking(id: number, productName: string, file: File, fileType: string) {
    return this.http.upload(`UserFiles/${productName}/${id}/${fileType}/upload`, file, fileType, this.authService.decode().auth);
  }

  downloadReleased(requestID: number, productName: string) {
    return this.http.get(`UserFiles/download/${productName}?mode=directLink&requestID=${requestID}`, this.authService.decode().auth);
  }

  downloadTemplateFile(productName: string) {
    return this.http.get(`UserFiles/template/${productName}`, this.authService.decode().auth);
  }
}
